import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../Constants/routes';
import logo from '../ic_launcher.png';

export default class Home extends Component {
    render() {
        return (
            <div className="cover-container d-flex h-100 p-3 mx-auto flex-column">
                <header className="masthead mb-auto">
                    <div className="inner">
                        <h3 className="masthead-brand">Conver.ai</h3>
                        <nav className="nav nav-masthead justify-content-center">
                            <Link className="nav-link active" to={ROUTES.HOME}>Home</Link>
                            <Link className="nav-link" to={ROUTES.FEATURES}>Features</Link>
                            <Link className="nav-link" to={ROUTES.PRIVACYPOLICY}>Privacy Policy</Link>
                        </nav>
                    </div>
                </header>

                <main role="main" className="inner cover">
                <img src={logo} style={{ height: "15rem", width: "15rem", borderRadius: "0.5rem", marginBottom: "2rem" }} alt="logo" />
                    <h1 className="cover-heading">Intelligent Currency Converter App</h1>
                    <p className="lead">Best app for frequent travellers</p>
                    <p className="lead">Uses artificial intelligence to detect currency values using the camera and convert 
                    to over 30 different currencies. Available on Google Play Store and coming soon to Apple App Store</p>
                    <p className="lead">
                    <Link className="btn btn-lg btn-secondary" to={ROUTES.FEATURES}>Learn more</Link>
                        
                    </p>
                </main>

               
            </div>
        )
    }
}
